// Generated by CoffeeScript 2.4.1
(function() {
  var $, ErrorCodes, LocalController, Promise, WeaverError;

  Promise = require('bluebird');

  WeaverError = require('./Error');

  ErrorCodes = require('./WeaverError');

  $ = {};

  LocalController = class LocalController {
    constructor(routes) {
      var handler, name;
      // We should never expose the routes
      $.routes = routes;
      $.handler = {};
      ((function() {
        var results;
        results = [];
        for (name in routes) {
          handler = routes[name];
          results.push(handler);
        }
        return results;
      })()).forEach((routeHandler) => {
        return routeHandler.allRoutes().forEach((route) => {
          var res;
          res = {
            success: function(data) {
              return Promise.resolve(data);
            },
            fail: function(error) {
              throw WeaverError(ErrorCodes.OTHER_CAUSE, error);
            }
          };
          return $.handler[route] = function(payload) {
            return routeHandler.handleRequest(route, {payload}, res);
          };
        });
      });
    }

    GET(path, body) {
      return $.handler[path](body);
    }

    POST(path, body) {
      return $.handler[path](body);
    }

  };

  module.exports = LocalController;

}).call(this);
